import { ENVIRONMENT_ENUM } from '@enums/environment.enum'

const AFFILIATIONS_PAYMENT_METHODS_ENUM = {
  PAG_SEGURO: 'PagSeguroConnect',
  PAG_SEGURO_STAGING: 'PagSeguroConnectStaging'
}

const ACQUIRER_BY_CONSENT_ENUM = {
  [AFFILIATIONS_PAYMENT_METHODS_ENUM.PAG_SEGURO]: 'pag_seguro',
  [AFFILIATIONS_PAYMENT_METHODS_ENUM.PAG_SEGURO_STAGING]: 'pag_seguro'
}

const ICON_COMPONENT_MAP = {
  [AFFILIATIONS_PAYMENT_METHODS_ENUM.PAG_SEGURO]: () =>
    import('./icons/AcquirerPagSeguroIcon.vue'),
  [AFFILIATIONS_PAYMENT_METHODS_ENUM.PAG_SEGURO_STAGING]: () =>
    import('./icons/AcquirerPagSeguroIcon.vue')
}

const AFFILIATIONS_BY_ENV = {
  [ENVIRONMENT_ENUM.PRODUCTION]: [AFFILIATIONS_PAYMENT_METHODS_ENUM.PAG_SEGURO],
  [ENVIRONMENT_ENUM.STAGING]: [
    AFFILIATIONS_PAYMENT_METHODS_ENUM.PAG_SEGURO_STAGING
  ]
}

const getAffiliationsByEnv = (env = process.env.VUE_APP_AMBIENCE) => {
  return AFFILIATIONS_BY_ENV[env]
}

export {
  ICON_COMPONENT_MAP,
  AFFILIATIONS_PAYMENT_METHODS_ENUM,
  ACQUIRER_BY_CONSENT_ENUM,
  getAffiliationsByEnv
}
